export default __webpack_public_path__ + "static/media/i006vp.375dfe80.webp";